import { render, staticRenderFns } from "./BaseSuccessButton.vue?vue&type=template&id=cafb3b4c&scoped=true"
import script from "./BaseSuccessButton.vue?vue&type=script&lang=js"
export * from "./BaseSuccessButton.vue?vue&type=script&lang=js"
import style0 from "./BaseSuccessButton.vue?vue&type=style&index=0&id=cafb3b4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafb3b4c",
  null
  
)

export default component.exports